<template>
	<div>
		<StrapiTable v-bind="table" :sortable="sortable">
			<SubmissionsTableRow
				v-for="i in items"
				:key="i.id"
				v-bind="i"
				:campaign-round="campaign.round"
				:updating="updating === i.id"
				:is-shortlist="isShortlist"
				@update="onUpdate"
				@view="onView"
			/>
		</StrapiTable>
		<!-- Approve/decline submission modal -->
		<Modal v-if="viewing" @close="viewing = null">
			<Submission
				v-if="currentSubmission"
				v-bind="currentSubmission"
				:updating="updating === currentSubmission.id"
				:is-shortlist="isShortlist"
				@update="onUpdateCurrent"
			/>
			<div v-else class="load">
				<Loading />
			</div>
		</Modal>
	</div>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import StrapiTable from '@/components/admin/StrapiTable'
import SubmissionsTableRow from '@/components/admin/SubmissionsTableRow'
import Modal from '@/components/admin/Modal'
import Submission from '@/components/admin/Submission'
import Loading from '@/components/shared/Loading'
import table from '@/mixins/table'

const tableMixin = table([
	{ column: 'title', label: 'Title' },
	{ column: 'name', label: 'Name' },
	{ column: 'email', label: 'Email' },
	{ column: 'created_at', label: 'Submitted', sort: 'DESC' },
	{ label: 'Actions' }
])

export default {
	name: 'submissions-table',
	props: {
		campaign: Object,
		isShortlist: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			updating: null,
			viewing: null
		}
	},
	computed: {
		currentSubmission() {
			return this.items.find(s => s.id === this.viewing)
		},
		nextSubmission() {
			// No next submission if not viewing or only one left
			const count = this.items.length
			if (this.viewing === null || count < 2) return null

			// Find current index, then add one
			const index = this.items.findIndex(item => item.id === this.viewing)
			return this.items[(index + 1) % count]
		}
	},
	methods: {
		async update({ id, ...payload }) {
			try {
				const body = JSON.stringify(payload)
				await this.patch(`/submissions/${id}`, { body })
				return true
			} catch (err) {
				return false
			}
		},
		async onUpdate(payload) {
			// Mark submission being updated
			this.updating = payload.id
			const success = await this.update(payload)

			if (success) {
				// Refresh parent list and
				// alert user that update was successful
				this.refresh({ update: true })
				this.toast(`Successfully updated the submission.`)
			} else {
				// Warn user that action failed
				this.toastErr(
					`Failed to update this submission. Please try again later.`
				)
			}

			this.updating = null
			return success
		},
		async onUpdateCurrent(payload) {
			const next = this.nextSubmission
			const success = await this.onUpdate(payload)

			// Move to next submission, or exit if last one
			if (success && this.viewing !== null) {
				this.viewing = next ? next.id : null
			}
		},
		onView({ id }) {
			this.viewing = id
		}
	},
	mixins: [api, toast, tableMixin],
	components: {
		StrapiTable,
		SubmissionsTableRow,
		Modal,
		Submission,
		Loading
	}
}
</script>

<style lang="scss" scoped>
.load {
	min-height: 16rem;
}
</style>
